import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-eligible-employees-popup',
  templateUrl: './eligible-employees-popup.component.html',
  styleUrls: ['./eligible-employees-popup.component.scss'],
})
export class EligibleEmployeesPopupComponent  implements OnInit {

  marketCorrectionEmployeesData:any[] = []
  getIncrementFyYearList:any[] = [];
  loggedInUserCompanyID:any
  loggedInCompanyFiscalyear:any
  fromYear:any;
  toYear:any;
  isToggleChecked:any = false;
  countMaleDaysServedTotal:any;
  countFeMaleDaysServedTotal:any;
  loggedInUserRole:any;
  isShowExcelData:any = false;


  constructor(private httpService: HttpService, private config: Config,
  private encryptionService: EncryptionService, private datePipe: DatePipe, private loader: LoaderService,
  ){}

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.getIncrementFYyear();
  }

  getIncrementFYyear(){
    const request =  {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }    
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result:any)=>{             
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        fromYear: ele.fromYear,
        toYear: ele.toYear,
        year: `${ele.fromYear}-${ele.toYear}`,
      }));
      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); 
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
          if(currentMonth<3){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          } 
        }
        if(this.loggedInCompanyFiscalyear === 'July_Jun'){
          if(currentMonth<6){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
          if(currentMonth<9){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.fromYear = this.getIncrementFyYearList[selectedYearIndex].fromYear;
      this.toYear = this.getIncrementFyYearList[selectedYearIndex].toYear;    

      this.getEligibleMaleEmployee();
      this.getEligibleFeMaleEmployee();
    })
  }
  getEligibleMaleEmployeeData:any = [];
  getEligibleFeMaleEmployeeData:any = [];

  maleTotalCount:any
  FeMaleTotalCount:any

  getEligibleMaleEmployee(){
    let request = {}
    if(this.loggedInUserRole == 'HOD'){
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": false,
        "eligibleMaleEmps": true,
        "fromYear": this.fromYear,
        "isHod": true,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }else{
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": false,
        "eligibleMaleEmps": true,
        "fromYear": this.fromYear,
        "isHod": false,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }
    this.httpService.callPostService(this.config.getDashboardLists, request).subscribe((result:any)=>{
      this.getEligibleMaleEmployeeData = result.data;
      this.calculateEligibleMaleEmployeeData(result.data)
      this.maleTotalCount = this.getEligibleMaleEmployeeData.reduce((total: number, department: any) => {
        return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
          return bandTotal + band.employeeData.length;
        }, 0);
      }, 0);
    })
  }

  getEligibleFeMaleEmployee(){
    let request = {}
    if(this.loggedInUserRole == 'HOD'){
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": true,
        "eligibleMaleEmps": false,
        "fromYear": this.fromYear,
        "isHod": true,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }else{
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": true,
        "eligibleMaleEmps": false,
        "fromYear": this.fromYear,
        "isHod": false,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }
    this.httpService.callPostService(this.config.getDashboardLists, request).subscribe((result:any)=>{
      this.getEligibleFeMaleEmployeeData = result.data;
      this.calculateEligibleFeMaleEmployeeData(result.data)
      this.FeMaleTotalCount = this.getEligibleFeMaleEmployeeData.reduce((total: number, department: any) => {
        return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
          return bandTotal + band.employeeData.length;
        }, 0);
      }, 0);
    })
  }

  getTotalRowSpan(bandGrades: any[]): number {
    let totalRows = 0;
    bandGrades.forEach(bandGrade => {
      totalRows += bandGrade.employeeData.length;
    });
    return totalRows;
  }

  calculateEligibleMaleEmployeeData(data: any[]){
    this.countMaleDaysServedTotal = 0;
    let totalDaysServedCount = 0

  data.forEach(department => {
        department.bandGrades.forEach((bandGrade: any) => {
          bandGrade.employeeData.forEach((employee: any) => {
            // this.countMaleDaysServedTotal += parseFloat(employee.daysServed || 0);
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.countMaleDaysServedTotal += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }            
          });
        });
      });
      if (totalDaysServedCount > 0) {
        this.countMaleDaysServedTotal = parseFloat((this.countMaleDaysServedTotal / totalDaysServedCount).toFixed(2));
      }
  }

  calculateEligibleFeMaleEmployeeData(data: any[]){
    this.countFeMaleDaysServedTotal = 0;
    let totalFemaleDaysServedCount = 0
  data.forEach(department => {
        department.bandGrades.forEach((bandGrade: any) => {
          bandGrade.employeeData.forEach((employee: any) => {
            // this.countFeMaleDaysServedTotal += parseFloat(employee.daysServed || 0);
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.countFeMaleDaysServedTotal += parseFloat(employee.daysServed);
              totalFemaleDaysServedCount++;
            }    
          });
        });       
      });
      if (totalFemaleDaysServedCount > 0) {
        this.countFeMaleDaysServedTotal = parseFloat((this.countFeMaleDaysServedTotal / totalFemaleDaysServedCount).toFixed(2));
      }  
  }


  exportToExcel() {
    this.loader.simpleLoader();
    this.isShowExcelData = true;
    const tableName = this.isToggleChecked ? 'feMaleData' : 'maleData';
  
    if(tableName == 'feMaleData'){
          setTimeout(() => {
            const currentDate = new Date();
            const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
            const flattenedData: any[] = [];
            const formatDate = (date: string) => {
              const formattedDate = new Date(date);
              return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
            };
            const currentYear = new Date().getFullYear();
            const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
            this.getEligibleFeMaleEmployeeData.forEach((department: any) => {
              department.bandGrades.forEach((band: any) => {
                band.employeeData.forEach((employee: any) => {
                  flattenedData.push({
                    "Department": department.departmentName,
                    "Band": band.band,
                    "Employee": employee.employeeName,
                    "Manager": employee.managerName,
                    "HOD": employee.hodName,
                    "DOJ": formatDate(employee.dateOfJoining),
                    "Eligible emp": employee.isEligible ? "Yes" : "No",
                    "Days served in the increment period": `${employee.daysServed || 0}`,
                  });
                });
              });
            });
            flattenedData.push({
              "Department": 'Total',
              "Band": '',
              "Employee": '',
              "Manager": '',
              "HOD": '',
              "DOJ": '',
              "Eligible emp": '',
              "Days served in the increment period": `${this.countFeMaleDaysServedTotal || 0}`,
            });
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
            const defaultCellStyle = {
              alignment: { horizontal: "left", vertical: "top" },
              font: { name: "Arial", sz: 12 }
            };
            const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
            for (let row = range.s.r; row <= range.e.r; row++) {
              for (let col = range.s.c; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
                if (worksheet[cellAddress]) {
                  worksheet[cellAddress].s = defaultCellStyle;
                }
              }
            }
            worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
            const workbook: XLSX.WorkBook = {
              Sheets: { 'data': worksheet },
              SheetNames: ['data'],
            };
            const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
            const fileName = `Eligible_Employee_Female_Data_${formattedDate}`;
            saveAs(data, fileName);
            this.isShowExcelData = false;
            this.loader.dismissLoader();
          }, 1000);
    }else if(tableName == 'maleData'){
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getEligibleMaleEmployeeData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                "Department": department.departmentName,
                "Band": band.band,
                "Employee": employee.employeeName,
                "Manager": employee.managerName,
                "HOD": employee.hodName,
                "DOJ": formatDate(employee.dateOfJoining),
                "Eligible emp": employee.isEligible ? "Yes" : "No",
                "Days served in the increment period": `${employee.daysServed || 0}`,
              });
            });
          });
        });
        flattenedData.push({
          "Department": 'Total',
          "Band": '',
          "Employee": '',
          "Manager": '',
          "HOD": '',
          "DOJ": '',
          "Eligible emp": '',
          "Days served in the increment period": `${this.countMaleDaysServedTotal || 0}`,
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: "left", vertical: "top" },
          font: { name: "Arial", sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
        const workbook: XLSX.WorkBook = {
          Sheets: { 'data': worksheet },
          SheetNames: ['data'],
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Eligible_Employee_Male_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    }
  }
}
